<template>
<div class="section section-yamap">
    <div v-if="offices.wait"><Dots class="loader" /></div>
    <div v-if="offices.list.length" class="section-inn slova">
        
        <div class="adr">
            
            <h1 v-if="cur_offi.is">{{cur_offi.item.title}}</h1>
            <div class="office-info" v-if="cur_offi.is">
                <p>
                    <strong>Адрес: </strong>{{cur_offi.item.city}}<span v-if="cur_offi.item.address">, {{cur_offi.item.address}}</span>
                </p>

                <p v-if="cur_offi.item.phone">
                    <strong>Телефон: </strong>{{cur_offi.item.phone}}
                </p>

                <p v-if="cur_offi.item.phone">
                    <strong>E-mail: </strong>{{cur_offi.item.mail}}
                </p>

                <p v-if="cur_offi.item.info" class="info-item pre" v-html="cur_offi.item.info"></p>

            </div>
        </div>
        <div class="list">
            <div class="office-togglers">
                <div class="office-toggler" :class="{'office-toggler_active': cur_offi.is && offi.id == cur_offi.item.id }" v-for="offi in offices.list" :key="offi.id" @click.prevent="set_cur(offi)">{{offi.city}}</div>
            </div>
        </div>
        
    </div>

    <div class="yadiv" ref="yadiv" :class="{'hidi': ymap.error || (cur_offi.is && !cur_offi.item.latlong)  }"></div>
    
</div>
</template>

<script setup>
import {ref, unref, onMounted} from 'vue'
import {isProd, _get} from '@/actions.js'
import Dots from '@/comp/Login/three-dots.vue'

const yadiv = ref(null) // карта DOM element

const offices = ref({// офисы
    wait: true,
    error: '',
    list: [],
})
const cur_offi = ref({
    is: false,
    item: null,
})

const ymap = ref({
    wait: true,
    map: null,
    error: '',
})

const set_cur = item => {
    const is = true
    cur_offi.value = {is, item}
    let {latlong} = item
    const {wait, map } = unref(ymap)
    if (!wait && latlong) {
        map.setCenter(latlong)
    }
}

const etoHost = isProd ? 'eto.travel' : 'eto.sereniti.ru'
const load = () => fetch(`https://${etoHost}/?rest_route=%2Fcustom%2Fv1%2Fposts%2F`).then(o => o.json()).then( 
    all => {
        if (!_get(all, '0.phone')) {
            console.error('backend-format 0.phone', all)
            return Promise.reject('неожиданный ответ')
        }
        return all
    }
).then( listin => { 
    let list = listin.filter( offi => offi.city  )
    list = list.sort( (a,b) => {
        if (a.order === b.order) {
            return a.city < b.city ? -1 : 1;
        }
        return (a.order < b.order) ? -1 : 1
    } )
    list = list.map( (offi, id) => {// latlong — [широта, долгота]
        const latlong = get_latlong(offi.geolocation)
        return {...offi, latlong, id}
    } )

    offices.value =  { wait: false, list, error: '' }
//console.log('list',list)    
    return true
}).catch(rej => {
    let error = rej.toString()

    offices.value =  { wait: false, list: [], error }
    return Promise.reject(rej)
})


function get_latlong(str) {
    let ret = null;
    if (str) {
        var splitStr = str.split(',');
        var lat = parseFloat(splitStr[0], 10);
        var lng = parseFloat(splitStr[1], 10);
        if (!isNaN(lat) && !isNaN(lng)) {
            ret = [lat, lng]
        }
    }
    return ret
}


const whenload=load()

const start_office = () => unref(offices).list[0] // тут может быть логика

onMounted(()=>{
    whenload.then( 
        () => {
            set_cur( start_office() )
            return window.ymaps ? ymaps.ready() : Promise.reject('не удалось загрузить яндекс карту')
        }
    ).then(
        () => { // гарантируем что ссылочка готова
            const map = new ymaps.Map( yadiv.value, {
              center: [55.7416448, 37.584896], 
              zoom: 12
            });
            ymap.value= {wait: false, map, error: ''}

            if (unref(cur_offi).is) {// если карта загрузилась позднее, то все равно все сработает
                let {latlong} = unref(cur_offi).item
                if (latlong) {
                    map.setCenter(latlong)
                }
            }
//console.log('xxx',document.getElementById('map').getBoundingClientRect()            )
            unref(offices).list.filter(offi => offi.latlong).forEach( offi => {

                const myPlacemark = new ymaps.Placemark(offi.latlong, {
                    hintContent: offi.title,
                    balloonContent: offi.address || ''
                }, {
                    // Опции.
                    // Необходимо указать данный тип макета.
                    iconLayout: 'default#image',
                    // Своё изображение иконки метки.
                    iconImageHref: '/i/marker.svg',
                    // Размеры метки.
                    iconImageSize: [40, 40],
                    // Смещение левого верхнего угла иконки относительно
                    // её "ножки" (точки привязки).
                    iconImageOffset: [0, 0]
                })
                map.geoObjects.add(myPlacemark)

            } )
        }, rej => {
            ymap.value= {wait: false, map: null, error: rej.toString() }
        }
    )
})

</script>

<style lang="scss">
@import "../assets/styles/cruise-styles.scss";

body.page .dbg {display: none;}

.section-yamap {
    padding: 60px 0;
    @include to(768px) {
        padding-top: 0;
    }    
    min-height: 500px;
    .loader {
        height: 25px;
        fill: #0057b7;
    }
    h1 {
        font-size: 32px;
        margin-bottom: 30px;
        @include to(768px) {
            font-size: 18px;
        }

    }
    .yadiv {
        height: 70vh;
        width: 100%;
    }

    .pre {
        white-space: pre;
    }
    .office-info p {
        font-size: 16px;
        line-height: 1.5;
    }

    div.slova {
        padding-bottom: 60px !important;
        display: flex;
        @include to(768px) {
            flex-direction: column;
        }
    }
    .adr {
        flex-basis: 100%; 
        flex-shrink: 1;
        @include to(768px) {
            flex-basis: auto;
            order: 2;
        }
    }
    .list {
        flex-basis: 270px; flex-shrink: 0;
        border-left: solid 1px #e3e3e3;
        @include to(768px) {
            flex-basis: auto;
            order: 1;
            border-left: none;
            margin-bottom: 30px;
        }

        .office-togglers {
            display: flex;
            margin-bottom: 1em;
            flex-wrap: wrap;
            margin: 10px 0 0 !important;
            flex-direction: column;
            @include to(768px) {
                flex-direction: row;
            }

        }



        .office-toggler {
            padding-left: 30px;
            @include to(768px) {
                width: 150px;
                padding-left: 0;
            }
        }

    }
    .hidi {display: none;}
}


.office-toggler {
  display: block;
  line-height: 1;
  text-decoration: none;
  font-weight: 700;
  font-size: 14px;
  color: #3d3d3d;
  margin: 12px 0;
  transition: 0.2s ease;
  padding: 0;
  border: 0;
  cursor: pointer;

  &:hover {
    color: #ff5c39;
  }

  &:first-child {
    margin-top: 5px;
  }

  &_active {
    color: #ff5c39;
    border: none;
    box-shadow: none;
    background: none;
    border-color: unset;
  }
}

.office-togglers {
  flex-direction: column;
}


</style>
